import { format } from 'date-fns';
import { CourseEnrollment, PATIENT_PROGRESS } from '../../types';

export function CourseEnrollmentInfo({
  courseEnrollments,
  progress,
}: {
  courseEnrollments: CourseEnrollment[];
  progress: PATIENT_PROGRESS;
}) {
  if (progress !== PATIENT_PROGRESS.COURSE_ENROLLED && courseEnrollments.length === 0) {
    return null;
  }

  if (progress === PATIENT_PROGRESS.COURSE_ENROLLED && courseEnrollments.length === 0) {
    return <>No enrolled course found</>;
  }

  return (
    <>
      {courseEnrollments
        .map(
          enrollment =>
            `Enrolled in ${enrollment.course.name} on ${format(
              new Date(enrollment.startDate),
              'dd-MM-yyyy'
            )}`
        )
        .join(', ')}
    </>
  );
}
